import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// Basic Components
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "OrderList";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-5">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={props.loggedBranch}
                    name={componentName + "BranchOption"}
                    label={LOOKUP.report.common.branch + "*"}
                    floatingLabelText={LOOKUP.report.common.branch + "*"}
                    hintText={LOOKUP.report.common.branch + "*"}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 m-0">
                <SelectInput
                    name={componentName + "OrderType"}
                    fullWidth={true}
                    label="Order Type*"
                    floatingLabelText="Order Type*"
                    defaultValue="0"
                    hintText="Order Type*"
                    options={props.orderTypes}
                />
            </div>
            {props.selectOrderType == 2 ?
                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3 m-0">
                    <SelectInput
                        name={componentName + "OrderPlatform"}
                        fullWidth={true}
                        label="Order Platform*"
                        floatingLabelText="Order Platform*"
                        defaultValue="0"
                        hintText="Order Platform*"
                        options={props.orderPlatforms}
                    />
                </div> : <div />
            }
            {props.selectOrderType == 2 ?
                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 m-0">
                    <SelectInput
                        name={componentName + "PaymentDelivery"}
                        fullWidth={true}
                        label="Payment & Delivery*"
                        floatingLabelText="Payment & Delivery*"
                        defaultValue="0"
                        hintText="Payment & Delivery*"
                        options={props.orderPaymentDelivery}
                    />
                </div> : <div />
            }
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                    disabled={props.disabled}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                    disabled={props.disabled}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p><b>Note: </b><strong className="blue-text"><i>Refunds are not counted in this report.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
